import { forwardRef, type Ref, type SVGProps } from "react";

function SvgFacilitySmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={63} height={60} fill="none" {...props}>
      <path
        stroke="url(#facility_small_svg__a)"
        strokeWidth={5}
        d="M54.5 55.5V29.143a4 4 0 0 0-4-4h-4.444m0 0V55.5m0-30.357V17a4 4 0 0 0-4-4H28.944a4 4 0 0 0-4 4v8.143m0 30.357V25.143m0 0H20.5a4 4 0 0 0-4 4V55.5"
      />
      <path
        fill="#0D2B57"
        d="M6.988 5.488a.487.487 0 1 0-.976 0c0 2.028-.447 3.377-1.297 4.227s-2.2 1.297-4.227 1.297a.488.488 0 0 0 0 .976c2.028 0 3.377.447 4.227 1.297s1.298 2.2 1.298 4.227a.488.488 0 0 0 .974 0c0-2.028.448-3.377 1.298-4.227s2.2-1.297 4.227-1.297a.488.488 0 0 0 0-.976c-2.028 0-3.377-.447-4.227-1.297s-1.298-2.2-1.298-4.227"
      />
      <path stroke="#0C1C43" d="M40 55v-6a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v6" />
      <defs>
        <linearGradient
          id="facility_small_svg__a"
          x1={35.5}
          x2={35.5}
          y1={13}
          y2={55.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgFacilitySmall);
export default ForwardRef;
